import axios from "axios";
import { config } from "../config/config";

const axiosInstanceJson = axios.create({
  baseURL: config.base.url,
  timeout: 5000,
  withCredentials: true,
});

// Add a request interceptor
axiosInstanceJson.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstanceJson;
